import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=4fa47d84&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.scss?vue&type=style&index=0&id=4fa47d84&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa47d84",
  null
  
)

export default component.exports